import React, { Component } from 'react'
import NavigationItems from './Components/NavigationItems'

import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'
import axios from 'axios'
import Base from './Config'
import WaveLoading from 'react-loadingg/lib/WaveLoading';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import ModalImage from "./assets/Nodemodules/react-modal-image";


class Items extends Component {
    edit=()=>{
        // console.log('Edit ',this.props.data);
        this.props.Edit(this.props.data)
    }

    delete=()=>{
        // console.log('delete ',this.props.data);
        this.props.Delete(this.props.data)
    }
    render() {
        // console.log('props ',this.props.data);
        const data = this.props.data
        return (
            // <tr>
            //     <th scope="row">{data.name}</th>
            //     <td>{data.ar_name}</td>
            //     <td>{data.price}</td>
            // </tr>
            <tr>
                <th scope="row">
                    {
                    data.h_string?
                    <>
                    {data.h_string}
                    <br/>
                    </>
                    :
                    <>
                    <label className="opacity-8">{"No header"}</label><br/>
                    </>
                    }

                    {data.ar_h_string&&<>{data.ar_s_string}<br/></>}
                    
                    {data.s_string?
                    <><label className="opacity-8">{data.s_string}</label><br/></>
                    :
                    <><label className="opacity-8">{"No Sub heading"}</label><br/></>
                    }
                    
                    {
                    data.ar_s_string&&
                    <>
                    <label className="opacity-5">{data.ar_s_string}</label><br/>
                    </>
                    }
                    
                    {
                    data.url?
                    <>
                    <a href={data.url} target="_blank">{data.url}</a><br/>
                    {/* <label className="opacity-5">{data.url}</label><br/> */}
                    </>
                    :
                    <>
                    <label className="opacity-5">{"No url"}</label><br/>
                    </>
                    }
                    </th>
                <td>
                    <ModalImage
                        small={data.pic}
                        large={data.pic}
                        hideDownload={true}
                        showRotate={true}
                    />
                    {/* <img src={data.pic} alt="width=&quot;50&quot;" height={33} /> */}
                </td>
                <td>{data.user_type=='O'?"Outsider":"Tenant"}</td>
                <td>
                    <button className="btn-sm btn-outline-primary" onClick={this.edit}>
                    <i className="fas fa-edit " ></i>
                    </button>
                    <span>&nbsp;</span>
                    <button className="btn-sm btn-outline-danger" onClick={this.delete}>
                    <i className="fas fa-trash"></i>
                    </button>
                </td>
            </tr>
        );
    }
}
export default class Header extends Component {
    constructor(){
        super()
        this.state={
            data:[],
            next:null,
            prev:null,
            loading:true,

            heading:'',
            subheading:'',
            user_type:'',
            bgimg:'',
            ebgimg:'',

            ar_h_string:"",
            ar_s_string:"",

            edit:false,
            id:'',

            url:"",
        }
    }

    AddHeader=()=>{
        // console.log('Headers/');
        // console.log(this.state)
        // console.log(this.state.bgimg)
        // return false

        if(!this.state.bgimg){
            NotificationManager.warning('Required : ', 'Background Image', 3000)
            return false
        }
        this.loading(true)


                
        var bodyFormData = new FormData();

        bodyFormData.set('pic', this.state.bgimg);
        bodyFormData.set('h_string', this.state.heading);
        bodyFormData.set('s_string', this.state.subheading);
        bodyFormData.set('url', this.state.url);
        bodyFormData.set('user_type', this.state.user_type);
        bodyFormData.set('ar_h_string', this.state.ar_h_string);
        bodyFormData.set('ar_s_string', this.state.ar_s_string);

        axios.post(
            Base.url + 'Headers/',
            bodyFormData,
        {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',3000)
                    this.fetchAllData()
                    this.loading(false)

                    this.setState({
                        heading:'',
                        subheading:'',
                        user_type:'',
                        url:"",
                        bgimg:"",
                    })
                    this.refs.bgimg.value=''

                }else{
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)

                    this.loading(false)

                }
        })
        .catch(error=>{
            console.log(error);
            NotificationManager.error('Error : ', error, 3000)
            this.loading(false)


        })
    }

    

    EditDay=()=>{
        // console.log('edit worked');
       
        // console.log('Headers/');
        // console.log(this.state.bgimg)
        // return false
                
        var bodyFormData = new FormData();
        if(this.state.bgimg){
            bodyFormData.set('pic', this.state.bgimg);
        }

        bodyFormData.set('id', this.state.id);
        bodyFormData.set('h_string', this.state.heading);
        bodyFormData.set('s_string', this.state.subheading);
        bodyFormData.set('url', this.state.url);
        bodyFormData.set('user_type', this.state.user_type);
        bodyFormData.set('ar_h_string', this.state.ar_h_string);
        bodyFormData.set('ar_s_string', this.state.ar_s_string);

        this.loading(true)

        axios.put(
            Base.url + 'Headers/',
            bodyFormData,
        {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
            if(response.data.Status){
                NotificationManager.success( response.data.Message,'Success : ',3000)
                this.fetchAllData()
                this.loading(false)
                this.clearEdit()
            }else{
                console.log(response.data.Message);
                console.log(response.data);
                NotificationManager.error('Error : ', response.data.Error, 3000)
                this.loading(false)
            }
        })
        .catch(error=>{
            console.log(error);
            this.loading(false)

        })
    }


    clearEdit=()=>{
        this.setState({
            edit:false,
            id:'',
            heading:'',
            subheading:'',
            user_type:'',
            url:"",
            ebgimg:"",
            ar_h_string:"",
            ar_s_string:"",
        })
        this.refs.bgimg.value=''
    }
    edit=(data)=>{
        NotificationManager.info("Please make changes in edit section","Info",5000)

        this.setState({
            edit:true,
            id:data.id,
            heading:data.h_string,
            subheading:data.s_string,
            user_type:data.user_type,
            ebgimg:data.pic,
            url:data.url,
            ar_h_string:data.ar_h_string,
            ar_s_string:data.ar_s_string,
        })
        // console.log('Edit parent data ',data);
    }
    deleteDay = (data)=>{
        // console.log('Delete parent data ',data);
        
        axios.delete(
            Base.url + 'Headers/?id='+data.id,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',3000)
                    this.fetchAllData()
                    this.loading(false)
                }else{
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)

                    this.loading(false)

                }
        })
        .catch(error=>{
            console.log(error);
        })
    }


    loading=(args)=>{
        this.setState({
            loading:args
        })
    }
    componentDidMount(){
        this.fetchAllData()
    }

    next=()=>{
        this.loading(true)
        axios.get(
          this.state.next.replace(/^http:\/\//i, 'https://'),
          { 
              headers: { 
                'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false, 

          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    prev=()=>{
        this.loading(true)
        axios.get(
          this.state.prev.replace(/^http:\/\//i, 'https://'),
          { 
              headers: { 
                  'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false,
          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    fetchAllData(){
        this.loading(true)
        axios.get(
            Base.url + 'Headers/',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                loading:false,
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }



    onChange=(e)=>{
        this.setState ({
            [e.target.name]:e.target.value
        })
    }
    render() {
        return (
            <div>
                {/* <NotificationContainer/> */}

                <NavigationItems />
                {/* Main content */}
                <div className="main-content">
                    <PageHeader pageName="Header" />

                    <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                        <div className="container-fluid">
                            <div className="header-body">
                                {/* Card stats */}
                                <div className="row">
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Page content */}
                    <div className="container-fluid mt--7">
                        <div className="row">
                            <div className="col-xl-8 mb-5 mb-xl-0">
                                <div className="card shadow">
                                    <div className="card-header border-0">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h3 className="mb-0">Header</h3>
                                            </div>
                                            <div className="col text-right">
                                            {this.state.prev==null?<button disabled={true} className="btn btn-sm btn-primary">Prev</button>:<button className="btn btn-sm btn-primary" onClick={this.prev}>Prev</button>}
                                        {this.state.next==null?<button disabled={true} className="btn btn-sm btn-primary">Next</button>:<button className="btn btn-sm btn-primary" onClick={this.next}>Next</button>}
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.loading?<WaveLoading/>:
                                    <div className="table-responsive">
                                        {/* Projects table */}
                                        <table className="table align-items-center table-flush">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th scope="col">Heading / SubHeading / URL</th>
                                                    {/* <th scope="col">Sub heading</th> */}
                                                    <th scope="col">Background image</th>
                                                    <th scope="col">User type</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.data.map((data,index)=>
                                                        <Items 
                                                        data={data} 
                                                        key={index}
                                                        Edit={this.edit}
                                                        Delete={this.deleteDay}
                                                        />
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
    }
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card shadow">
                                    <div className="card-header bg-transparent">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                {/* <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6> */}
                                                <h2 className="mb-0" />
                                                {
                                                this.state.edit?
                                                <h2><i className="fas text-red fa-window-close pr-4" onClick={this.clearEdit}></i>Edit Header</h2>
                                                :
                                                <a  className="card-header bg-transparent"><h2>Create Header</h2></a>
                                                }
                                            </div>
                                        </div>
                                        <form role="form">
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input className="form-control" name="heading" value={this.state.heading} onChange={this.onChange} placeholder="Header name" type="text" />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input className="form-control" name="ar_h_string" value={this.state.ar_h_string} onChange={this.onChange} placeholder="اسم الرأس" type="text" />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input className="form-control" name="subheading" value={this.state.subheading} onChange={this.onChange} placeholder="Sub heading" type="text" />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input className="form-control" name="ar_s_string" value={this.state.ar_s_string} onChange={this.onChange} placeholder="العنوان الفرعي" type="text" />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input className="form-control" name="url" value={this.state.url} onChange={this.onChange} placeholder="https://www.example.com/" type="text" />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <select className="form-control-sm form-control" style={{borderColor:'#fafafa',boxShadow:'0px 2px 1px #ededed'}}  name="user_type" value={this.state.user_type} onChange={this.onChange}>
                                                        <option value='' disabled>Select user type</option>
                                                    {/* { this.state.allData.map((option,index) => <option key={index} value={option.id} >{option.name}</option>)} */}
                                                    <option  value="O" >Outsider</option>
                                                    <option  value="T" >Tenant</option>
                                                    </select>
                                                </div>
                                            </div>
                                            Background Image
                                            {this.state.edit&&<img   height={33} src={this.state.ebgimg} />}
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">
                                                            {/* <input className="form-control" type="file" onchange="readURL(this);" /> */}
                                                            <input className="form-control" type="file"  ref='bgimg'  onChange={(event) => {this.setState({bgimg: event.target.files[0]})}  }  />
                                                            
                                                            </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-center text-muted mb-4">
                                                {/* <small>Or sign up with credentials</small> */}
                                            </div>
                                        </form>
                                        <div className="text-center">
                                            {
                                            this.state.edit?
                                            <button type="button" className="btn btn-primary mt-4" onClick={this.EditDay}>Save</button>
                                            :
                                            <button type="button" className="btn btn-primary mt-4" onClick={this.AddHeader}>Add</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>

        )
    }
}
